import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import {css} from 'aphrodite';
import {renderMultifieldString} from 'libs/salmon-utils';
import TabularDataBasic from 'components/TabularDataBasic';
import Markdown from 'components/Markdown';
import {renderModalField} from 'libs/components';

/**
 * @deprecated Use CoverageSummaryModal from ./CoverageSummary/modal.jsx instead
 * Wrapper component to handle state for the coverage summary modal
 */
export const CoverageSummaryModal = (props) => {
  const {
    rowData,
    settings,
    styleSheet,
    handleHide,
    showSummaryModal,
    handleDocumentClick,
  } = props;

  if (!rowData) {
    return null;
  }

  const summaryColumns = [
    {
      accessorKey: 'id',
      enableSorting: false,
      header: () => '',
      cell: ({cell}) => {
        return (<strong>{cell.getValue()}</strong>);
      },
    },
    {
      accessorKey: 'initialTherapy',
      enableSorting: false,
      header: () => 'Initial Therapy',
      cell: ({cell}) => {
        return (<span className={css(styleSheet.initialTherapyCell)}>{cell.getValue()}</span>);
      },
      meta: {className: css(styleSheet.initialTherapyColumn)},
    },
    {
      accessorKey: 'continuedTherapy',
      enableSorting: false,
      header: () => 'Continued Therapy',
      cell: ({cell}) => {
        return (<span className={css(styleSheet.continuedTherapyCell)}>{cell.getValue()}</span>);
      },
      meta: {className: css(styleSheet.continuedTherapyColumn)},
    }
  ];

  return (
    <Modal
      show={showSummaryModal}
      onHide={handleHide}
      aria-labelledby={'summary-modal-title'}
      backdrop={true}
      size='lg'
      backdropClassName={css(styleSheet.modalBackdrop)}
      dialogClassName={`pal-modal ${css(styleSheet.coverageSummaryModal)}`}
      className={css(styleSheet.modal)}
    >
      <Modal.Header closeButton>
        <Modal.Title id={'summary-modal-title'} className={'summary-modal-title'}>
          {rowData &&
            renderMultifieldString(settings.table.coverageSummaryModal.title, rowData)
          }
        </Modal.Title>
      </Modal.Header>
      <div>
        {settings.table.coverageSummaryModal.layout === 'default' &&
          <Modal.Body className={'summary-modal-body'}>
            <div>
              <div style={{marginBottom: '15px'}}>
                <label className={css(styleSheet.coverageSummaryModalLabel)}>
                  <span>{renderMultifieldString(settings.table.coverageSummaryModal.subtitle, rowData)}</span>
                </label>
              </div>
              {settings.table.coverageSummaryModal.body.map((block) => {
                return renderModalField(
                  block,
                  rowData,
                  styleSheet,
                  `coverageSummaryModalBody${block.property}`,
                  'coverageSummaryModalLabel'
                );
              })}
            </div>
          </Modal.Body>
        }
        {settings.table.coverageSummaryModal.layout === 'table' &&
          <>
            <p style={{padding: '15px 15px 0'}}>{rowData.states.join(', ')}</p>
            <div className={css(styleSheet.dataTable)}>
              <TabularDataBasic
                data={rowData.coverageSummaryFields}
                columns={summaryColumns}
              />
            </div>
          </>
        }
      </div>
      {
        settings.table.coverageSummaryModal.layout === 'table' &&
        <Modal.Footer className={'pal-modal-footer'}>
          <span>The above summary does not reflect the complete criteria as published by the payor.</span><br/>
          {(rowData && rowData.policyUrl) &&
            <span>Please refer to the <a  onClick={(e) => {
              handleHide();
              handleDocumentClick(e);
            }} href={rowData.policyUrl}>Coverage Document</a> link to view the entire criteria.</span>
          }
        </Modal.Footer>
      }
      {settings.table.coverageSummaryModal.disclaimer &&
        <Modal.Footer className={css(styleSheet.coverageSummaryModalFooter)}>
          <Markdown>{settings.table.coverageSummaryModal.disclaimer}</Markdown>
        </Modal.Footer>
      }
    </Modal>
  );
};

CoverageSummaryModal.protoTypes = {
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
  handleHide: PropTypes.func.isRequired,
  handleDocumentClick: PropTypes.func.isRequired,
  showSummaryModal: PropTypes.bool,
  customLayout: PropTypes.bool.isRequired,
};